export default function getSearchbarPlaceholder ({ item }) {
    let res = 'Search'
    if (!item) return res

    res += ' ( '
    const map = {
        title: 'title',
        label: 'title',
        description: 'description',
        id: 'id',
        handle: 'handle',
    }
    
    for (const key of Object.keys(map)) {
        if (item[key]) {
            res += map[key] + ', '
        }
    }

    res = res.slice(0, -2)
    res += ' )'

    return res
}


// WEBPACK FOOTER //
// ./src/helpers/get-searchbar-placeholder.js